import React from "react";
import { usePreferences } from "../../hooks";
import ACLStore from "lib/aclStore";
import { ENABLE_CONFIGURATION_FETCHING_OPTIMISATION } from "Constants/permissionConstants";
import { getDisplayName } from "Utils/HOCHelpers";

const WithPreferences = hocConfiguration => Component => {
  function SetupPreferences(props) {
    const shouldSkipQuery =
      hocConfiguration?.skip?.(props) ||
      !ACLStore.can(ENABLE_CONFIGURATION_FETCHING_OPTIMISATION);

    const { variables, fetchPolicy = "cache-and-network" } = !shouldSkipQuery
      ? hocConfiguration.options(props)
      : {};

    const { data, loading } = usePreferences({
      variables,
      fetchPolicy,
      skip: shouldSkipQuery,
    });
    if (shouldSkipQuery) {
      return <Component {...props} />;
    }

    const derivedProps = hocConfiguration.props
      ? hocConfiguration.props({ ownProps: props, data })
      : {};

    const isLoading = loading || props.isLoading;

    const isData = !!data && props.isData;

    return (
      <Component
        {...props}
        {...derivedProps}
        isLoading={isLoading}
        isData={isData}
      />
    );
  }

  SetupPreferences.displayName = `WithPreferences(${getDisplayName(
    Component
  )})`;

  return SetupPreferences;
};

export default WithPreferences;
